import { getSiteDisplayTitle, isBuiltinSite, listCustomSites } from '../state/siteIndex';

export const ETALON_SITE_TITLE = 'Триповерховий офіс';

export type SiteNavTab = {
  to: string;
  label: string;
  end?: boolean;
};

export function siteIdFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/site\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export function siteSectionTabs(siteId: string): SiteNavTab[] {
  return [
    { to: `/site/${siteId}`, label: 'Моніторинг', end: true },
    { to: `/site/${siteId}/edit`, label: 'Редактор' },
    { to: `/site/${siteId}/devices`, label: 'Обладнання' },
    { to: `/site/${siteId}/events`, label: 'Події' },
    { to: `/site/${siteId}/history`, label: 'Історія' },
  ];
}

export function resolveSiteTitle(siteId: string): string {
  if (isBuiltinSite(siteId)) return ETALON_SITE_TITLE;
  const custom = listCustomSites().find((site) => site.id === siteId);
  return custom ? getSiteDisplayTitle(custom) : siteId;
}
